import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

/**
 * 警告メッセージを表示する
 * @param  {array} {messages}
 * @return {object}
 */
function WarningMessageArea({messages}) {
  let warnList = [];
  const intl = useIntl();
  if (messages) {
    warnList = getWarnList(intl, messages);
  }
  return (
    <React.Fragment>
      {warnList && warnList.length > 0 &&
      <Grid key="warningMessageGrid">
        <Typography key="warningMessageArea" variant="caption" component="div"
          style={{width: '100%',
            height: '100px', // 5行分
            overflowY: 'scroll',
            borderBottom: 'solid 1px'}}>
          {warnList}
        </Typography>
      </Grid>
      }
    </React.Fragment>
  );
};

function getWarnList(intl, messages) {
  let warnList = [];
  let index = 0;
  for (const message of messages) {
    console.debug(message.id);
    let msg = '';
    let messageId = message.id.indexOf('message') == -1 ?
      'message.' + message.id : message.id;
    if (Object.hasOwn(message, 'text')) {
      msg = message.text;
    } else if (Object.hasOwn(message, 'values')) {
      msg = intl.formatMessage({id: messageId}, message.values);
    } else {
      msg = intl.formatMessage({id: messageId});
    }
    console.debug(msg);
    const outerMsg = message.id + ' ' + msg;
    if (message.id.indexOf('E') >= 0) {
      warnList.push(<span key={message.id + index++} style={{'color': 'red', 'display': 'block'}}>{outerMsg}</span>);
    } else if (message.id.indexOf('W') >= 0) {
      warnList.push(<span key={message.id + index++} style={{'color': 'orange', 'display': 'block'}}>{outerMsg}</span>);
    } else {
      warnList.push(<span key={message.id + index++} style={{'color': 'black', 'display': 'block'}}>{outerMsg}</span>);
    }
  }
  return warnList;
}


/**
 * 確認画面用警告メッセージ
 * @param {string} procName 処理名
 * @param {string} fixAction 修正方法
 * @return {object}
 */
export function ConfirmWarningMessageArea({procName, fixAction='前画面に戻って'}) {
  let message = {
    id: 'BFY000115E',
    values: [procName, fixAction],
  };

  const intl = useIntl();
  let msg = intl.formatMessage({id: 'message.' + message.id}, message.values);

  return (
    <Grid key="confirmWarningMessageGrid">
      <Typography key="confirmWarningMessageArea" variant="h6" component="div" style={{'color': 'red', 'display': 'block'}}>
        {msg}
      </Typography>
    </Grid>
  );
};

WarningMessageArea.propTypes = {
  messages: PropTypes.array,
};
ConfirmWarningMessageArea.propTypes = {
  procName: PropTypes.string,
  fixAction: PropTypes.string,
};

export default WarningMessageArea;
